/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const FeaturedArticleFragment = {
  FeaturedArticle: gql`
    fragment FeaturedArticleQuery on featuredArticle_Entry {
      componentTitle
      styles
      typeHandle
      featuredArticles {
        slug
        title
        ... on visionTemplateEntry_Entry {
          blogSummary
          featuredEntryImage {
            url
            ... on images_Asset {
              altText
            }
          }
        }
      }
      cardCtaOverride {
        ctaCardOverrideLink
        cardNumber
      }
    }
  `,
};
